import { DownOutlined } from '@ant-design/icons';
import { FC } from 'react';
import styles from './SortByTogglers.module.scss';

interface CollapseHeaderProps {
  title: string;
  badge: string;
}

const CollapseHeader: FC<CollapseHeaderProps> = ({ title, badge }) => (
  <div className={styles.contentHeader}>
    <div className={styles.headerMain}>
      <p className={styles.headerTitle}>{title}</p>

      <DownOutlined className={`${styles.headerIcon}`} />
    </div>

    <div className={`${styles.headerBadge}`}>{badge}</div>
  </div>
);

export { CollapseHeader };
